var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTraslate2Line = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7371_20594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20898 4.16659L10.0423 8.74992H9.1444L8.64398 7.49992H6.93982L6.44023 8.74992H5.54273L7.37565 4.16659H8.20898ZM4.66732 0.833252V1.66659H7.16732V2.49992H6.34732C6.02591 3.46745 5.51293 4.36034 4.83898 5.12534C5.13953 5.39351 5.46552 5.63172 5.81232 5.83659L5.4994 6.61908C5.0517 6.36516 4.63298 6.06325 4.25065 5.71867C3.50631 6.39231 2.62483 6.89666 1.6669 7.197L1.44357 6.39325C2.26433 6.13155 3.02066 5.69964 3.66315 5.12575C3.18761 4.58739 2.79151 3.98378 2.4869 3.33325H3.42023C3.65246 3.76194 3.93093 4.16392 4.25065 4.532C4.77153 3.93163 5.18203 3.2438 5.46315 2.50034L1.33398 2.49992V1.66659H3.83398V0.833252H4.66732ZM7.79232 5.36867L7.27273 6.66658H8.31107L7.79232 5.36867Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7371_20594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "currentColor",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTraslate2Line, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/traslate-2-line.fea28c1f.svg";
export { ForwardRef as ReactComponent };